import { useCategoryStore } from '@/stores/category'
import { decodeCategories, encodeCategories } from '~/helpers/categoryCodec'

export default defineNuxtPlugin(async (nuxtApp: any) => {
  const categoriesStore = useCategoryStore(nuxtApp.$pinia)

  if (import.meta.server) {
    await categoriesStore.fetchCategories()
    // The list goes to the browser compact (~180 kB instead of ~520 kB of Pinia state, one JSON.parse instead of
    // reviving 1700 objects before hydration: mobiilinopeus 23.10.2026). Moved after rendering, which uses the full
    // list, and before the payload is serialized.
    nuxtApp.hooks.hook('app:rendered', () => {
      if (!categoriesStore.categories.length) return
      nuxtApp.payload.categoryList = encodeCategories(categoriesStore.categories)
      categoriesStore.categories = []
    })
    return
  }

  // In the browser: the list that came with the page, or (pages rendered only in the browser, a failed server fetch) the API
  if (typeof nuxtApp.payload.categoryList === 'string') {
    categoriesStore.setCategories(decodeCategories(nuxtApp.payload.categoryList))
  }
  else if (!categoriesStore.categories.length) {
    await categoriesStore.fetchCategories()
  }
})
